import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import "./_style.scss";
import { headTitleList, stepperData } from "./parts";
import TkStepper from "../../components/atoms/TkStepper";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { httpIAPI_FAC040, httpIAPI_FAC041 } from "./api/request";
import { FacilityKind } from "../../assets/data/Constants";
import { IAPI_FAC040_Response } from "../../type/apiType";

/**
 * SCRC050121 廃止・休止・経営移管施設一覧
 * @return SCRC050121 廃止・休止・経営移管施設一覧
 */
const SCRC050121 = () => {
  const navigate = useNavigate();

  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const applyId = businessState.job_18?.applyId;
  const [res, setRes] = useState<IAPI_FAC040_Response>({});
  const [bodyListData, setBodyListData] = useState<any>();
  const [btnStatus, setBtnStatus] = useState(true);

  //登録（施設情報） ボタン用イベント
  const handleFacilityInfoRegist = (
    facilityNo: any,
    obosoleteStatus?: string
  ) => {
    navigate("/SCRC050122", { state: { facilityNo, obosoleteStatus } });
  };

  //登録（職員の異動状況） ボタン用イベント
  const handleStaffTransferRegist = (
    facilityNo: any,
    facilityName: any,
    transferDate?: any,
    staffTransferStatus?: string
  ) => {
    navigate("/SCRC050123", {
      state: {
        facilityNo,
        facilityName,
        transferDate,
        staffTransferStatus,
      },
    });
  };

  // 削除ボタン用イベント
  const handleDelete = async (facilityNo: any) => {
    if (applyId) {
      // 廃止対象施設削除API 実行
      try {
        const deletedResult = await httpIAPI_FAC041({
          applyId,
          contractorNo:
            state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
              ? businessState.common?.contractorNo
              : state.authInfo?.contractorNo,
          facilityNo,
        });

        if (deletedResult.resultCd === "I0000") {
          setState({
            ...state,
            errorMsgId: "",
          });

          const newStatusList =
            res.statusList?.filter?.((s) => s?.facilityNo !== facilityNo) || [];
          setRes({ ...res, statusList: newStatusList });
          setBtnStatus(
            newStatusList?.some(
              (i) =>
                i.obosoleteStatus === "未登録" ||
                i.staffTransferStatus === "未登録" ||
                i.staffTransferStatus === "登録中"
            ) ?? false
          );
        } else {
          setState({
            ...state,
            errorMsgId: deletedResult.resultCd,
          });
          return;
        }
      } catch (error) {
        navigate("/error");
      }
    }
    let facilityList = businessState.job_18?.facilityList?.filter(
      (item) => item.facilityNo !== facilityNo
    );
    setBusinessState({
      ...businessState,
      job_18: {
        ...businessState.job_18,
        facilityList,
      },
    });
    // 削除後の持回情報.施設情報リストが0件の場合、廃止・休止・経営移管施設選択画面に遷移する
    if (!facilityList?.length) {
      navigate("/SCRC050120");
    }
  };

  const handleInit = async () => {
    // 施設廃止状況一覧参照API 実行
    try {
      const res = await httpIAPI_FAC040({
        applyId,
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
        facilityList: businessState.job_18?.facilityList?.map((item) => ({
          facilityNo: item.facilityNo,
        })),
      });

      if (res.resultCd === "I0000") {
        setRes(res);
        setBtnStatus(
          res.statusList?.some(
            (i) =>
              i.obosoleteStatus === "未登録" ||
              i.staffTransferStatus === "未登録" ||
              i.staffTransferStatus === "登録中"
          ) ?? false
        );
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch {
      navigate("/error");
    }
  };

  // 初期表示
  useEffect(() => {
    applyId && handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let bodyList = businessState.job_18?.facilityList?.map((item) => {
      let resInfo = res?.statusList?.find(
        (i) => i.facilityNo === item.facilityNo
      );

      return [
        {
          children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
        },
        {
          children:
            FacilityKind[item.facilityKind as keyof typeof FacilityKind],
        },
        {
          children: (
            <Box className="status">
              <Typography>
                {"廃止情報：" + (resInfo?.obosoleteStatus ?? "未登録")}
              </Typography>
              <Typography>
                {"職員の異動先：" + (resInfo?.staffTransferStatus ?? "未登録")}
              </Typography>
            </Box>
          ),
        },
        {
          children: (
            <TkButton
              data-testid="fixButton"
              onClick={() =>
                handleFacilityInfoRegist(
                  item.facilityNo,
                  resInfo?.obosoleteStatus
                )
              }
            >
              登録
            </TkButton>
          ),
          align: "center",
        },
        {
          children: (
            <TkButton
              disabled={resInfo?.obosoleteStatus !== "登録完了"}
              data-testid="fixButton"
              onClick={() =>
                handleStaffTransferRegist(
                  item.facilityNo,
                  item.facilityName,
                  resInfo?.obsoleteDate,
                  resInfo?.staffTransferStatus
                )
              }
            >
              登録
            </TkButton>
          ),
          align: "center",
        },
        {
          children: (
            <TkButton
              data-testid="fixButton"
              onClick={() => handleDelete(item.facilityNo)}
            >
              削除
            </TkButton>
          ),
          align: "center",
        },
      ];
    });

    setBodyListData(bodyList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessState.job_18?.facilityList, res]);

  return (
    <Box className="SCRC050121" data-testid="SCRC050121PageForTest">
      <TkStepper steps={stepperData} activeStep={1}></TkStepper>
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050121_01}</TkInfoManual>

      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState?.common?.contractorNo ?? ""}:${
            businessState?.common?.contractorName ?? ""
          }`}
        />
      )}

      <TkTable headList={headTitleList} bodyList={bodyListData}></TkTable>

      <Box className="btn">
        <TkBackButton />
        <TkButton
          data-testid="nextButton"
          onClick={() => {
            navigate("/SCRC050024");
          }}
          disabled={btnStatus}
        >
          次へ
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRC050121;
